import { datadogLogs } from "@datadog/browser-logs";

datadogLogs.init({
  clientToken: "pub42c9d118e6376b134403112162f7aa6c",
  site: "datadoghq.eu",
  service: "shopify-theme",
  env: import.meta.env.MODE,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
});

export { datadogLogs };
